export const AttributeIconSpecs = {
    "authors": 'person',
    "keywords": 'insert_comment',
    "commitTypes": 'label',
    "clocByFiles": 'insert_drive_file',
    "touchCountByFiles": 'insert_drive_file',
    "clocByDirs": 'folder',
    "touchCountByDirs": 'folder',
}